import moment from "moment";
import React from "react";
import { commonUtils } from "../../../../../redux/_common";
import { TCRBRecord } from "../../../../../redux/app/crb/@types";
import { TCRBJ1 } from "../../../../../redux/app/crb/groups/crb-j";
import CRBTableRows from "../CRBTableRows";

type OwnProps = {
	crbRecord: TCRBRecord;
	isStrikedOff?: boolean;
};
type CRBJ1PreviewProps = OwnProps;
function CRBJ1Preview(props: CRBJ1PreviewProps) {
	const crbRecord = props.crbRecord as TCRBJ1;
	const operationDate = moment(crbRecord.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<CRBTableRows
				record={crbRecord}
				tableRows={[
					[operationDate, "J", 29, renderItem29()],
					[null, null, 30, renderItem30()],
					[null, null, 31, renderItem31()],
					[null, null, 32, renderItem32()],
					[null, null, 33, renderItem33()],
					[null, null, 34, renderItem34()],
					[null, null, 35, renderItem35()],
					[null, null, 36, renderItem36()],
					[null, null, 37, renderItem37()],
					[null, null, "NOTE", crbRecord.remarks],
				]}
			/>
		);
	}

	function renderItem29() {
		const { placeOfBallast } = crbRecord.item29;
		if (placeOfBallast.place === "IN_PORT") {
			return (
				<h4 className="font-medium uppercase">
					Surveyed at: {placeOfBallast.portName}
				</h4>
			);
		}
	}

	function renderItem30() {
		if (crbRecord.item30.tanks.length > 0) {
			const totalQuantityDischarged = crbRecord.item30.tanks.reduce<number>(
				(result, tank) => commonUtils.addUp(tank.transferQuantity, result),
				0
			);
			return (
				<>
					<table className="min-w-full table-auto border-collapse">
						<thead className="bg-gray-600">
							<tr>
								<th className="px-4 py-2 border text-center">Tank</th>
								<th className="px-4 py-2 border text-center">
									Discharge Quantity
								</th>
								<th className="px-4 py-2 border text-center">Catgeory</th>
								<th className="px-4 py-2 border text-center">Substance</th>
							</tr>
						</thead>
						<tbody>
							{crbRecord.item30.tanks.map((tank) => {
								return (
									<tr key={tank.selectedTank.id}>
										<td className="px-4 py-2 border text-center">
											{tank.selectedTank.tankCode}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.transferQuantity}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.catgeory}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.substance}
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>

					<br />
					<h4 className="font-medium uppercase">
						Total Quantity Discharged: {totalQuantityDischarged.toFixed(2)} M³
					</h4>
				</>
			);
		}
		return <>----</>;
	}
	function renderItem31() {
		return (
			<h4 className="font-medium uppercase">
				{crbRecord.item31.tanksPumpPipingSystemEmptied ? "Yes" : "No"}
			</h4>
		);
	}
	function renderItem32() {
		return (
			<h4 className="font-medium uppercase">
				{crbRecord.item32.prewashCarriedOut ? "Yes" : "No"}
			</h4>
		);
	}
	function renderItem33() {
		return (
			<h4 className="font-medium uppercase">
				{crbRecord.item33.dischargedAshoreAndEmptyTank ? "Yes" : "No"}
			</h4>
		);
	}
	function renderItem34() {
		return (
			<h4 className="font-medium uppercase">
				{crbRecord.item34.exemptionGranted ? "Yes" : "No"}
			</h4>
		);
	}
	function renderItem35() {
		return (
			<h4 className="font-medium uppercase">
				{crbRecord.item35.exemptionReason
					? crbRecord.item35.exemptionReason
					: "----"}
			</h4>
		);
	}
	function renderItem36() {
		return (
			<h4 className="font-medium uppercase">
				{crbRecord.item36.nameOfSurveyor
					? crbRecord.item36.nameOfSurveyor
					: "----"}
			</h4>
		);
	}
	function renderItem37() {
		return (
			<h4 className="font-medium uppercase">
				{crbRecord.item37.surveyorOrganisation
					? crbRecord.item37.surveyorOrganisation
					: "----"}
			</h4>
		);
	}

	return renderMain();
}

export default CRBJ1Preview;
